import React from 'react';
import ReactDOM from 'react-dom/client';
import LeaveCalendar from './components/LeaveCalendar.jsx';
import './calendar.css';
import './index.css';
import ReactModal from 'react-modal';
import App from './App.js'; // ✅ 改為載入 App.js（注意副檔名）
ReactModal.setAppElement('#root')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<LeaveCalendar />);